/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Community Manager API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
/**
 * InheritedRolesControllerApi - axios parameter creator
 */
export const InheritedRolesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * For the specified user, get a mapping from company IDs to the lists of associated inherited roles.
         * @summary Get inherited roles for a user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInheritedRoles: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getInheritedRoles', 'userId', userId)
            const localVarPath = `/inherited-roles/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InheritedRolesControllerApi - functional programming interface
 */
export const InheritedRolesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InheritedRolesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * For the specified user, get a mapping from company IDs to the lists of associated inherited roles.
         * @summary Get inherited roles for a user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInheritedRoles(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInheritedRoles(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InheritedRolesControllerApi.getInheritedRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InheritedRolesControllerApi - factory interface
 */
export const InheritedRolesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InheritedRolesControllerApiFp(configuration)
    return {
        /**
         * For the specified user, get a mapping from company IDs to the lists of associated inherited roles.
         * @summary Get inherited roles for a user.
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInheritedRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.getInheritedRoles(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InheritedRolesControllerApi - interface
 */
export interface InheritedRolesControllerApiInterface {
    /**
     * For the specified user, get a mapping from company IDs to the lists of associated inherited roles.
     * @summary Get inherited roles for a user.
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInheritedRoles(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }>;

}

/**
 * InheritedRolesControllerApi - object-oriented interface
 */
export class InheritedRolesControllerApi extends BaseAPI implements InheritedRolesControllerApiInterface {
    /**
     * For the specified user, get a mapping from company IDs to the lists of associated inherited roles.
     * @summary Get inherited roles for a user.
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInheritedRoles(userId: string, options?: RawAxiosRequestConfig) {
        return InheritedRolesControllerApiFp(this.configuration).getInheritedRoles(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

